document.addEventListener("DOMContentLoaded", function () {
    var widgetContainerId = 'esdm-widget-container';
    var targetElement = document.getElementById(widgetContainerId);

    if (!targetElement) return;

    // Pastikan path ini sesuai lokasi file JSON di server Anda
    var dataUrl = "/content/images/harga_acuan.json";

    // KEAMANAN: Fungsi escape HTML untuk mencegah XSS
    function escapeHtml(str) {
        if (typeof str !== 'string') return '';
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    fetch(dataUrl)
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Gagal memuat data');
            }
            return response.json();
        })
        .then(function (data) {
            renderWidget(data, targetElement);
        })
        .catch(function () {
            targetElement.innerHTML = '<div class="esdm-widget-box"><div class="esdm-error">Data harga belum tersedia.</div></div>';
        });

    function renderWidget(data, container) {
        // KEAMANAN: Semua data dari JSON di-escape sebelum rendering
        var periode = escapeHtml(data.periode || '');
        var komoditasHtml = (data.komoditas || []).map(function (item) {
            return '<li>' +
                '<span class="esdm-name">' + escapeHtml(item.nama || '') + '</span>' +
                '<div class="esdm-price-box">' +
                '<span class="esdm-price">$' + escapeHtml(String(item.harga || '')) + '</span>' +
                '<span class="esdm-unit">' + escapeHtml(item.unit || '') + '</span>' +
                '</div>' +
                '</li>';
        }).join('');

        var html =
            '<div class="esdm-widget-box">' +
            '<h3 class="esdm-title">Harga Acuan Mineral &amp; Batubara</h3>' +
            '<p class="esdm-periode">Periode: <strong>' + periode + '</strong></p>' +
            '<ul class="esdm-list">' + komoditasHtml + '</ul>' +
            '<small class="esdm-source">Sumber: Ditjen Minerba Kementerian ESDM</small>' +
            '</div>';
        container.innerHTML = html;
    }
});